/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_List_No_Chats_DescriptionInputs */



/**
* | output |
* | --- |
* | "Start your first chat by creating a project and asking a question." |
*
* @param {Chat_List_No_Chats_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_list_no_chats_description = /** @type {((inputs?: Chat_List_No_Chats_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_List_No_Chats_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Starte deinen ersten Chat, indem du ein Projekt erstellst und eine Frage stellst.")
	return /** @type {LocalizedString} */ ("Start your first chat by creating a project and asking a question.")
});